module.exports = __webpack_public_path__ + "img/arrange-circle-2.6d0254ef.svg";